import React from 'react';

import Popup from '../../Popup';

import styles from './welcomePopUps.scss';

const OrganizerWelcomePopUp = ({
    onCloseClick,
    onCtaClick,
    memberName,
}) => {
    return (
        <Popup
            className={`popup-md`}
            popUpClassName={`${styles.welcomePopUp}`}
            onCloseClick={onCloseClick}
            config={{
                noPadding: true,
                fullScreen: false,
                topGradient: false,
                scrollable: false,
            }}
            data-testid="modal.organizer-welcome"
        >
            <div className={`${styles.section} pt0`}>
                <h4 data-testid="modal.organizer-welcome.title">
                    {`Welcome ${memberName}!`}
                    <span className="d-block" data-testid="modal.organizer-welcome.subtitle">
                            Start by creating your first event.
                    </span>
                </h4>
            </div>
            <div className={`${styles.section} pt0`}>
                <p data-testid="modal.organizer-welcome.description">
                        It&apos;s easy to organize level-based events for your members. From draw-based tournaments to casual club hit arounds, organizing play has never been simpler.
                </p>
                <div className="bb" />
                <button
                    type="button"
                    className="btn btn-primary btn-xl btn-block text-uppercase"
                    onClick={onCtaClick}
                    data-testid="modal.organizer-welcome.cta-btn"
                >
                        Try it
                </button>
            </div>
        </Popup>
    );
};

export default OrganizerWelcomePopUp;
